
import {useParams} from 'react-router-dom'
import GalleryItem from '../Components/GalleryItem'
import AppearOnScroll from './AppearOnScroll';




function CenterTextImage(props) {
    let {projectName} = useParams();
    let projects = require("../projects.json");
    let project = projects.filter(project => project.project_name === projectName)[0];

    return (
        <AppearOnScroll duration={0.2}>
        <div className='flex flex-col gap-8 xl:gap-12'>
            <div className='flex flex-row justify-center w-full'>
                <h3 className='font-display font-medium text-2xl xl:text-2xl text-center'>Results</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-8 xl:px-12 w-full overflow-hidden aspect-4/3">
                
                {project.gallery.map(section => (
                    <GalleryItem
                    image={section.image}
                    pill={section.pill}
                    colSpan={section.colSpan}
                    /> 
                ))}   
               
            </div>
             
        </div>
        </AppearOnScroll>
        
    // <div className='grid grid-cols-2 gap-4 w-full'>
    //     <div className='bg-black w-full h-32'></div>
    //     <div className='bg-black w-full h-32'></div>
    //     <div className='bg-black w-full h-32 col-span-2'></div>
    // </div>
    );
  }
  
  export default CenterTextImage;